<template>
  <div>
    <UeModal name="ok_modal" :title="header" :maxWidth="600" @before-open="beforeOpen">
      <div class="mb-5">
        <p>{{ body }}</p>
      </div>
      <div class="d-flex justify-content-end">
        <b-button variant="primary" @click="ok()">Ok</b-button>
      </div>
    </UeModal>
  </div>
</template>
<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      header: null,
      body: null,
    }
  },
  methods: {
    show(params = {}) {
      this.$openModal('ok_modal', params)
    },
    ok() {
      window.Events.$emit('on:ok')
      this.$closeModal('ok_modal')
    },
    beforeOpen(e) {
      this.header = e.params.header
      this.body = e.params.body
    },
  },
})
</script>
